import React, { useEffect, useState } from "react";
import ButtonComp from "../ButtonComp/ButtonComp";
import {
    Col,
    DatePicker,
    Row,
    Spin,
    Modal,
    Form,
    Input,
    Select,
    Table,
    InputNumber,
    TimePicker,
} from "antd";
import {
    SwapOutlined,
    RedoOutlined,
    RetweetOutlined,
    CloseCircleOutlined,
    CheckCircleFilled,
    CloseCircleFilled,
    CheckCircleOutlined,
    CaretRightOutlined,
    ExclamationCircleOutlined,
} from "../../Utils/imports";
import Divider from "../Divider/Divider";
import CustomTable from "../Table/CustomTable";
import {
    access_capabilities,
    drawerLineOPData,
    LineOpData,
    lineOperatorOptions,

    RejectionModalTableColumns,
} from "../../Utils/constants";
import MainDrawer from "../Drawer/Drawer";
import { addCircle, edit } from "../../Utils/imports";
import CategoryBox from "../CategoryBox/CategoryBox";
import "./LineOperatorComp.css";
import Datepicker from "../Datepicker/Datepicker";
import { LineOperatorCompVar } from "../../Utils/variables";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { onDowntimeRangeChange } from "../../Redux/features/downtime.slice";
import { setPageLoader } from "../../Redux/features/utils.slice";
import { getDowntimeLogList } from "../../API-Interaction/apiServices/downtime.api";
import {
    antIcon, canForceStop, canPerformAction, dateFormatter, formatCapabilities, splitSelectionCriteria, timeFormatter, validateForMerge,
    validateForSplit,convertSecsToTime
} from "../../Helpers/helpers";
import BasicModal from "../Modals/BasicModal/BasicModal";
import { forceStopShift, getDowntimeLogs, mergeDowntimes, splitDowntimes, updateDowntime, updateLineRange } from "../../API-Interaction/apiServices/logs.api";
import { error } from "../../Helpers/notification";
import Loader from "../Helpers/Loader";
import { info } from "../Helpers/notification";
import Timer from "../Timer/Timer";
import { getDynamicAdjustmentList } from "../../API-Interaction/apiServices/dynamicAdjustment.api";
import ReworkRejection from "./ReworkRejection.modal";
import ForceShiftStop from "./ForceShiftStop";
import { getProductsList } from "../../API-Interaction/apiServices/productionLine.api";
import { changeProduct } from "../../API-Interaction/apiServices/logs.api";
import machineBatchQuery from "../../Utils/AuthProvider"

const { Option } = Select;
const { RangePicker } = DatePicker;
const { line_operator } = LineOperatorCompVar;

const LineOperatorComp = () => {
    const { pageLoaders, componentLoaders } = useSelector((state) => state?.utils.loaders);
    const { line, machine, plant } = useSelector(state => state?.plant?.current)
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [categoryBox1, setCategoryBox1] = useState({ list: null, selected: null })
    const [categoryBox2, setCategoryBox2] = useState({ list: null, selected: null })
    const [categoryBox3, setCategoryBox3] = useState({ list: null, selected: null })
    const [isReasonSelected, setIsReasonSelected] = useState(false);
    const [type, setType] = useState()
    const [modalStates, setModalStates] = useState({})
    const [comment, setComment] = useState(null)
    const [selectedDowntime, setSelectedDowntime] = useState(null)
    const [checkedDowntimes, setCheckedDowntimes] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState()
    const [splitTime, setSplitTime] = useState()
    const [downtimeComment, setDowntimeComment] = useState()
    const [productModal, setProductModal] = useState(false);
    const [step, setStep] = useState(1);
    const onLineOpRangeChange = (date, dateString) => {
        updateLineRange(date, dateString, dispatch)
    };

    let selector = useSelector((state) => state.downtime);

    const handleModal = (task, type) => {
        setType(type)
        if (task === 'open') {
            setDowntimeComment('');
            setModalStates({ ...modalStates, [type]: true });
          }
        if (task === 'close')
            setModalStates({ ...modalStates, [type]: false })
    }

    const onClose = () => {
        setCategoryBox1({})
        setCategoryBox2({})
        setCategoryBox3({})
        setIsReasonSelected(false)
        setComment(null)
        setOpen(false)
    }
    const handleCommentModal = (record) =>{
        setSelectedDowntime(record)
        if(record.comment)
        setDowntimeComment(record.comment)
        handleModal('open', 6)
    }
    const showDrawer = (key, rec) => {
        console.log({ current })
        setSelectedDowntime(rec)
        if(current.machine){            
            setCategoryBox1({ list: current?.machine?.reasons || current?.line?.reasons })
        }
        else
            setCategoryBox1({ list: current?.line?.reasons })
        setOpen(true)
    }

    const { current = null, lists } = useSelector(state => state.plant)
    const { downtimes, lineOpRange } = useSelector(state => state.logs)
    const { products } = useSelector(state => state.productionLine)
    const [selectedMachines, setSelectedMachines] = useState([current?.machine?.machineName]);
    const [selectedProd, setSelectedProd] = useState(null); 
    const { page, component } = useSelector(state => state.utils.reloadFlags)
    function canSync() {
        if ((lists?.machines.length>1))
          return true
        return false
      }
      function canSyncMachine(x){
          const { machine } = current;
          if ((!machine && x.machineName == 'Default') || (machine && x.machineName == machine.machineName))
            return true
          return false
        
      }

    const rowHandler = {
        selectedRowKeys: selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowKeys(selectedRowKeys)
            setCheckedDowntimes(selectedRows)
        }
    };

    useEffect(() => {
        current?.line && getProductsList(dispatch,current)
        current?.plant && getDowntimeLogs(dispatch, current, lineOpRange, 'lineOperator')
        setCheckedDowntimes([])
        setSelectedRowKeys()
    }, [current, lineOpRange, page, component])

    const handleSave = async () => {
        let categories = []
        let reason = ''
        if (!categoryBox1.selected)
            return error('Please Select a category!')
        if (categoryBox1.selected)
            {
                categories.push(categoryBox1.selected)
                reason = categoryBox1.selected;
            }
        if (categoryBox2.selected){
            categories.push(categoryBox2.selected)
            reason = categoryBox2.selected;
        }
        if (categoryBox3.selected){
            categories.push(categoryBox3.selected)
            reason = categoryBox3.selected;
        }
        // setIsReasonSelected(false)
        let body = {
            categories: categories,
            comment: comment || selectedDowntime?.comment || '',
            record: selectedDowntime,
            page: 'lineOperator',
            reason:reason
        }
        await updateDowntime(body, dispatch, current)
        onClose()
    }
    const handleSaveComment = async () => {
        //let categories = []
        //let reason = ''
        //if (!categoryBox1.selected)
         //   return error('Please Select a category!')
        //if (categoryBox1.selected)
         //   {
         //       categories.push(categoryBox1.selected)
         //       reason = categoryBox1.selected;
         //   }
        //if (categoryBox2.selected){
        //    categories.push(categoryBox2.selected)
        //    reason = categoryBox2.selected;
       // }
       // if (categoryBox3.selected){
       //     categories.push(categoryBox3.selected)
       //     reason = categoryBox3.selected;
       // }
        let body = {
            //categories: categories,
            comment: downtimeComment ,
            record: selectedDowntime,
            page: 'lineOperator',
            //reason:reason
        }
        await updateDowntime(body, dispatch, current)
        onClose()
    }

    const LineOpColumns = [
        ...lineOperatorOptions,
        {
            title:'Duration',
            dataIndex:'started',
            render: (key, rec) => {
                //let {hours,minutes,seconds} = moment.duration(moment(rec.ended).diff(moment(rec.startedAt).toDate()))._data;
                //let time = (hours*60*60)+(minutes*60)+seconds
                //if((rec.ended!=null)||(rec.ended!='')) 
                return rec.duration
 
        }

        }
        ,
        {
            title: "Reason",
            dataIndex: 'reason',
            render: (key, rec) => (key === '' || key == null) ? <button onClick={() => showDrawer(key, rec)} className="dflex alignCenter justifySB gap10" style={{ color: "#1E6EFE", background: "transparent", border: "none", cursor: "pointer" }}><img src={addCircle} /> Add Reason </button> : key
        },
        {
            title: "Comments",
          dataIndex: "comment",
          render: (key, record) =>key === 'N/A'? <button onClick={() => handleCommentModal(record)} className="dflex alignCenter justifySB gap10 commentBtn" > Comment </button>:key
        }
    ];

    const selectCategory1 = (rowKey, category) => {
        let data = []
        let reasons = current?.machine?.reasons || current?.line?.reasons
        Object.keys(reasons).map(key => {
            if (key === category)
                data = reasons[category]
        })
        setCategoryBox1({ ...categoryBox1, selected: category, index: rowKey })
        if(!data[0])
            setCategoryBox2({ list: data, selected:  null, index: null })
        else
            setCategoryBox3({ list: data, selected: null, index: null })
    }

    const selectCategory2 = (rowKey, category) => {
        //if (categoryBox1.selected === "Breakdowns - Mechanical") {
            let data = []
            Object.keys(categoryBox2.list).map(key => {
                if (key === category)
                    data = categoryBox2.list[category]
            })
            setCategoryBox2({ ...categoryBox2, selected: category, index: rowKey })
            setCategoryBox3({ list: data })
            return
        //}
       // setCategoryBox2({ ...categoryBox2, index: rowKey, selected: category })
       // setCategoryBox3({})
    }

    const selectCategory3 = (rowKey, category) => {
        setCategoryBox3({ ...categoryBox3, selected: category, index: rowKey })
        setIsReasonSelected(true);
    }

    const LineOpDrawerData = (
        <div className='dflex flexColumn gap20'>
          <Row className='drawerInfo_row1'>
            <Col sm={12} md={6}><strong>Status:</strong> {selectedDowntime?.status}</Col>
            <Col sm={12} md={6}><strong>Time:</strong> {selectedDowntime?.started}</Col>
            <Col sm={12} md={6}><strong>Date:</strong> {moment(selectedDowntime?.startedAt).format('DD-MM-YY')}</Col>
            {/* <Col sm={12} md={6}><strong>Detected Issue:</strong> {selectedDowntime?.reason}</Col> */}
          </Row>
          <Row>
            {categoryBox1?.list &&
              <Col span={7} className='dflex alignCenter justifyCenter gap10'>
                <CategoryBox heading = 'Category' categoryData={categoryBox1?.list} selectedCategory={categoryBox1?.index} selectCategory={selectCategory1} />
              </Col>
            }
            {categoryBox2?.list &&
              <>
                <div className="dflex justifyCenter alignCenter">
                  <CaretRightOutlined className="drawerICON" />
                </div>
                <Col span={7} className='dflex alignCenter justifyCenter gap10'>
                  <CategoryBox heading = 'Sub Category' categoryData={categoryBox2?.list} selectedCategory={categoryBox2?.index} selectCategory={selectCategory2} />
                </Col>
              </>
            }
            {categoryBox3?.list &&
              <>
                <div className="dflex justifyCenter alignCenter">
                  <CaretRightOutlined className="drawerICON" />
                </div>
                <Col span={7} className='dflex alignCenter justifyCenter gap10'>
                  <CategoryBox heading = 'Reason' categoryData={categoryBox3?.list} selectedCategory={categoryBox3?.index} selectCategory={selectCategory3} />
                </Col>
              </>
            }
          </Row>
            {/* </div> */}
        </div>
    )

    const MergeModalData = (
        <div className="dflex flexColumn alignCenter justifyCenter">
            <div style={{ width: 250 }}>
                <p className="p" style={{ textAlign: "center" }}>
                    You are merging downtimes from
                </p>
                {
                    checkedDowntimes?.map((downtime, index) => (
                        <div key={index} style={{ textAlign: 'center' }}>
                            <strong>{dateFormatter(downtime?.startedAt, 'hh:mm:ss')}</strong>
                            -
                            <strong> {dateFormatter(downtime?.ended, 'hh:mm:ss')}</strong>
                            <strong> ({dateFormatter(downtime?.startedAt, 'Do MMMM')})</strong>
                        </div>
                    ))
                }


                <p className="p" style={{ textAlign: "center" }}>
                    with a separation time of:
                </p>
            </div>
            <p>
                <strong>{checkedDowntimes[0]?.duration}</strong>
            </p>
            <p>Are you sure you want to merge?</p>
        </div>
    );

    const getTime = (time) => {
        let first = (time)?.toString()?.split('T')[1]
        let then = (first)?.toString()?.split('.')[0]
        return then
    }
    const filterPassedTime = (dateString) => {
        const abc = new Date(dateString);
        let saveTimeEnable = (abc.getTime() > new Date(checkedDowntimes[0]?.startedAt).getTime() && abc.getTime() < new Date(checkedDowntimes[0]?.ended).getTime());
        console.log(saveTimeEnable);
        if(!saveTimeEnable)
        {
            let { hours, seconds, minutes } =moment.duration(new moment(checkedDowntimes[0]?.ended || new Date()).diff(new moment(checkedDowntimes[0]?.startedAt)))._data;
            
            minutes = (hours*60) + minutes;
            let abc = moment(checkedDowntimes[0].startedAt)
                .add((minutes/2), 'minutes')
                .toDate();

            setSplitTime(moment(abc, ["h:mm A"]).format("HH:mm"))    

            console.log(abc,'time updated by system....')
        }
        else 
            setSplitTime(moment(dateString, ["h:mm A"]).format("HH:mm"))
        console.log(splitTime);
        return saveTimeEnable;
    };
    const SplitModalData = (
        <div className="dflex flexColumn alignCenter justifyCenter w100">
            <div className="dflex w100 justifySB alignCenter">
                <p>
                    <strong>{dateFormatter(checkedDowntimes[0]?.startedAt, 'hh:mm:ss A')}</strong>
                    <strong> ({dateFormatter(checkedDowntimes[0]?.startedAt, 'Do MMMM YYYY')})</strong>
                </p>
               {/* <Slider
                    style={{ width: "100%", marginRight: "15px", marginLeft: "15px" }}
                    // defaultValue={checkedDowntimes[0]?.startedAt}
                    min={checkedDowntimes[0]?.startedAt}
                    max={checkedDowntimes[0]?.ended}
                    tooltip={{
                        open: false
                    }}
                />*/
                }
                <p>
                    <strong>{dateFormatter(checkedDowntimes[0]?.ended,'hh:mm:ss A')}</strong>
                    <strong> ({dateFormatter(checkedDowntimes[0]?.ended, 'Do MMMM YYYY')})</strong>
                </p>
            </div>
            <p>TIME TO SPLIT AT</p>
            <TimePicker 
            onChange={(date, dateString) => setSplitTime(moment(dateString, ["h:mm A"]).format("HH:mm"))} style={{ textAlign: "center" }} use12Hours={true}  />
            {/* {splitSelectionCriteria(splitTime,
                checkedDowntimes[0]?.ended,
                checkedDowntimes[0]?.startedAt).disabled &&
                <p className="error_para">{
                    splitSelectionCriteria(splitTime,
                        checkedDowntimes[0]?.ended,
                        checkedDowntimes[0]?.startedAt).error
                }</p>
            } */}
            
        </div>
    );

    // const FStopModalData = (
    //     <div>
    //         <h4
    //             style={{
    //                 fontWeight: 600,
    //                 fontSize: 14,
    //                 textTransform: "uppercase",
    //                 textAlign: "center",
    //             }}
    //         >
    //             Are you sure you want to stop this shift early?
    //         </h4>
    //         <h4>
    //             Current Machine: <strong>{current?.machine?.displayName}</strong>
    //         </h4>
    //         <h4>
    //             Current SHIFT: <strong>{current?.shift?.name}</strong>
    //         </h4>
    //         <h4>
    //             Shift Range : <strong>{current?.shift?.range}</strong>
    //         </h4>
    //     </div>
    // );

    const ModalTableData = [
        {
            key: "1",
            time: "12:56:13",
            user: "Irzum",
            value: 20,
            ratio: 0.2,
        },
        {
            key: "1",
            time: "12:56:13",
            user: "Irzum",
            value: 20,
            ratio: 0.2,
        },
        {
            key: "1",
            time: "12:56:13",
            user: "Irzum",
            value: 20,
            ratio: 0.2,
        },
    ];

    const ModalTablecolumns = [
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "User",
            dataIndex: "user",
            key: "user",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
        },
        {
            title: "Ratio",
            dataIndex: "ratio",
            key: "ratio",
        },
    ];

    const RejectionModalTableColumns = [
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "User",
            dataIndex: "user",
            key: "user",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
        },
        {
            title: "Ratio",
            dataIndex: "ratio",
            key: "ratio",
        },
    ];

    const RejectionModalData = (
        <div style={{ width: "100%" }}>
            <Row>
                <Form style={{ width: "100%" }} layout="vertical">
                    {line?.isTreet &&
                        <Row gutter={24}>
                            <Col span={12}>
                                <Form.Item className="w100">
                                    <DatePicker
                                        className="w100 boxBg boxBorderRad"
                                        placeholder="Select Date"
                                        style={{ border: "none" }}
                                        allowClear={false}

                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item>
                                    <Select
                                        className="w100 boxBg boxBorderRad"
                                        placeholder="Select Shift"
                                        bordered={false}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>}
                    <Form.Item
                        label={<p className="boldText w100">VALUE</p>}
                        name="value"
                        rules={[{ required: true, message: "Please input a value!" }]}
                    >
                        <InputNumber defaultValue={0} className="boxBorderRad" />
                    </Form.Item>
                    <Form.Item
                        label={<p className="boldText w100">RATIO (PRIMARY VALUE)</p>}
                        name="ratio"
                        rules={[{ required: true, message: "Please input a value!" }]}
                        className='width100P'
                    >
                        <InputNumber defaultValue={1} className="boxBorderRad" />
                    </Form.Item>
                </Form>
            </Row>
            <Row className="dflex flexColumn">
                <h4 className="boldText">Logs</h4>
                <Table
                    dataSource={ModalTableData}
                    columns={RejectionModalTableColumns}
                    pagination={false}
                />
            </Row>
        </div>
    );

    const ReworkModalData = (
        <div style={{ width: "100%" }}>
            <Row>
                <Form style={{ width: "100%" }} layout="vertical">
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item className="w100">
                                <DatePicker
                                    className="w100 boxBg boxBorderRad"
                                    placeholder="Select Date"
                                    style={{ border: "none" }}
                                    allowClear={false}

                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item>
                                <Select
                                    className="w100 boxBg boxBorderRad"
                                    placeholder="Select Shift"
                                    bordered={false}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        label={<p className="boldText w100">VALUE</p>}
                        name="value"
                        rules={[{ required: true, message: "Please input a value!" }]}
                    >
                        <Input defaultValue={0} className="boxBorderRad" />
                    </Form.Item>
                </Form>
            </Row>
            <Row className="dflex flexColumn">
                <h4 className="boldText">Logs</h4>
                <Table
                    dataSource={ModalTableData}
                    columns={ModalTablecolumns}
                    pagination={false}
                />
            </Row>
        </div>
    );

    const EditCommentModal = (
        <Row>
            <Col span={24}>
            <Input className="boxBorderRad" placeholder="Add Comment." type='text' value={downtimeComment} onChange={(e) => setDowntimeComment(e.target.value)} />
            </Col>
            <Col style={{ padding: '10px' }} className="dflex justifyLeft alignCenter m-1" span={24}>
                <ExclamationCircleOutlined style={{ color: 'gray' }} />
                <p style={{ marginLeft: '5px', color: 'gray' }}>Type 'Planned Downtime' to reverse impact OEE.</p>
            </Col>
        </Row>
    );

    const handleMerge = () => {
        let { error = '', isValid } = validateForMerge(checkedDowntimes);
        if (!isValid)
            return info(error)
        //Sorting by time ( StartedAt )
        checkedDowntimes?.sort((a, b) => a.startedAt.localeCompare(b.startedAt))
        let { hours, seconds, minutes } = moment.duration(new moment(checkedDowntimes[1]?.startedAt || new Date()).diff(new moment(checkedDowntimes[0]?.ended)))._data
        let duration = timeFormatter(hours) + ':' + timeFormatter(minutes) + ':' + timeFormatter(seconds)
        let updatedDowntimes = checkedDowntimes?.map((downtime) => ({ ...downtime, duration: duration }))
        setCheckedDowntimes(updatedDowntimes)
        handleModal('open', 1)
    }
    const onRejectionClick = () => {
        getDynamicAdjustmentList(dispatch, current)
        handleModal('open', 3);
    }
    const onReworkClick = () => {
        getDynamicAdjustmentList(dispatch, current)
        handleModal('open', 4);
    }
    const handleProductModal = () => {
        setSelectedMachines([current?.machine?.machineName])
        setProductModal(true);
      };
      const handleModalClose = () => {
        setProductModal(false);
        setStep(1);
      };
      let changeParams = {}
      const handleProductChange = () => {
        let currentShift = current?.shift
        let currentShiftProduct = current?.shift?.product
        let shifts = line.shifts ? [...line.shifts] : [];

        if (machine)
          shifts = machine.shifts ? [...machine.shifts] : [];
        
          
        if (!currentShift?.product.secondary)
        {
          let productBefore = products.find(product => product.id === currentShift?.product.id);
          productBefore = {
            id: productBefore.id,
            name: productBefore.productName,
            lineSpeed: productBefore.lineSpeed,
            primary: productBefore.primary,
            secondary: productBefore.secondary
          }
          if(line.isRazorLine)
             productBefore.Weight = productBefore.Weight? productBefore.Weight : null;
        //   currentShift.product = productBefore
        }
        // find the selected product from model via give id from input field
        let selectedProduct = products.find(product => product.productName === selectedProd);

        if (selectedProduct) {
          selectedProduct = {
            id: selectedProduct._id,
            name: selectedProduct.productName,
            lineSpeed: selectedProduct.lineSpeed,
            primary: selectedProduct.primary,
            secondary: selectedProduct.secondary
          };
        } else {
          console.log('Selected product not found in data');
          return;
        }
        
        if(line.isRazorLine)
          selectedProduct.Weight = selectedProduct.Weight? selectedProduct.Weight : null;
        const { fromTime, toTime, ...obj } = current?.shift
        let detailsAfter = {
          ...currentShift,
          product: selectedProduct,
        }
        if (detailsAfter['fromTime'])
          delete detailsAfter['fromTime']
        if (detailsAfter['toTime'])
          delete detailsAfter['toTime']

        let log = {
          lineId: line?.id,
          lineName: line.lineName,
          hallName: line.hallName,
          shiftName: currentShift.name == null ? '' : currentShift.name,
        //   userId: loggedUser.id,
        //   email: loggedUser.email,
          time: new Date(),
          plantName: plant.plantName,
          plantId: plant.id,
          action: 'Shift Updated',
          detailsBefore : obj,
          detailsAfter
        }
        changeParams = {
            shifts: shifts,
            currentShift: currentShift,
            selectedProduct: selectedProduct,
            obj: obj,
            line: line,
            detailsAfter: detailsAfter,
            dispatch: dispatch,
            log: log,
            machine: machine,
            plantId: plant.id,
          };
        
        setStep(2)
      };
      const saveSyncArray = async(product) => {
    
        // let products = await machineBatchQuery({
        //   lineId: line.id,
        //   plantId: plant.id,
        //   queries: [{'lineId':line.id, machine: null}].concat(line.machines.map(x => {return {'lineId':line.id, machine: x.machineName}}))
        // ,conditions: {'productName':product}})
        // this.setState({products})
      };
  const handleAllShifts = async () => {
    await handleProductChange();

      let {
      shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine
    } = changeParams
    // if (userCan('machine-access') && productionLine.machines && productionLine.machines.length)
    // {
      
    //   await saveSyncArray(changeParams.selectedProduct.name)
      
    //   return
    // }

      shifts = shifts.reduce((accumulator, shift) => {
        return accumulator.concat({
          ...shift,
          product: selectedProduct,
        });
    }, []);
    
  canSync() ? setStep(3) :  changeProduct(shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine, plant._id);
}

const handleCurrentShift = async() => {
    await handleProductChange();
    let {
        shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine
      } = changeParams
    //   if (userCan('machine-access') && productionLine.machines && productionLine.machines.length)
    //   {     
  
        // await saveSyncArray(changeParams.selectedProduct.name)
      
    //     return
    //   }
      shifts = shifts.reduce((accumulator, shift) => {
        if (currentShift.range === shift.range) {
          return accumulator.concat({
            ...shift,
            
            product: selectedProduct,
          });
        }
        return accumulator.concat(shift);
      }, []);
  canSync() ? setStep(3) : changeProduct(shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine, plant._id);
}

const productChange = async() => {
    await handleAllShifts();
    let {
        shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine
      } = changeParams
    await  changeProduct(shifts, currentShift, selectedProduct, obj, line, detailsAfter, dispatch, log, machine, plant._id);
    handleModalClose();
}

    return (
        <Loader loading={pageLoaders?.lineOperator}>
            <div className='dflex flexColumn gap20 p20 '>
                <div className='lineOp_head dflex alignCenter justifySB'>
                    <h1 className='pageHead'>{line_operator}</h1>
                    <div className='dflex alignCenter justifyCenter gap10'>
                        <BasicModal id="1" title="Merge" children={MergeModalData}
                            btn1Text="Merge" btn2Text="Cancel" open={modalStates['1'] || false}
                            handleOK={async () => {
                                await mergeDowntimes(checkedDowntimes, dispatch, current);
                                handleModal('close', 1)
                            }}
                            handleCancel={() => { setSelectedRowKeys(); setCheckedDowntimes([]); handleModal('close', 1) }}
                            loading={componentLoaders?.merge || false}
                        />

                        <BasicModal id="2" title="Split" children={SplitModalData} btn1Text="Split" btn2Text="Cancel" open={modalStates['2'] || false}
                            handleOK={async () => {
                                await splitDowntimes({ ...checkedDowntimes[0], splitTime: splitTime }, dispatch, current)
                                handleModal('close', 2)
                            }}
                            // okDisabled={splitSelectionCriteria(splitTime, checkedDowntimes[0]?.startedAt, checkedDowntimes[0]?.ended).disabled}
                            handleCancel={() => { setSelectedRowKeys(); setCheckedDowntimes([]); handleModal('close', 2) }}
                            loading={componentLoaders?.split || false}
                        />
                         <Modal
                            title={<h2 style={{fontWeight: 'bold'}}>Change Product</h2>}
                            centered
                            maskClosable={false}
                            open={productModal}
                            onCancel={handleModalClose}
                            footer={null}
                            className="fsModal"
                        >
                        {step === 1 && (
                            <div>
                                <Select
          style={{ width: '100%' }}
          onChange={value => setSelectedProd(value)}
          defaultValue={current?.shift?.product.name}
        >
          {products.map(machine => (
            <Select.Option key={machine.productName} value={machine.productName}>
              {machine.productName}
            </Select.Option>
          ))}
        </Select>
                    <div className="dflex alignCenter justifyCenter gap10 pt20" >
                    <ButtonComp
                        className="btnBlue"
                        style={{ width: "100px" }}
                        theme="blue"
                        text="Save"
                        onClick={() => handleProductChange()}
                        icon={<CheckCircleFilled />}
                        />
             <ButtonComp
               className="btnBlue"
               style={{ width: "100px" }}
               theme="red"
               text="Cancel"
               onClick={() => handleModalClose()}
               icon={<CloseCircleFilled />}
             />
             </div>
             </div>
          )}
          {step === 2 && (
            <div>
            <h4 style={{fontWeight: "bold"}}>Do you want to change the product for All Shifts?</h4>
            <div className="dflex alignCenter justifyCenter gap10 pt20" >
            <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="blue"
                  text="Yes"
                  onClick={() => handleAllShifts()}
                  icon={<CheckCircleFilled />}
                />
                <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="red"
                  text="No"
                  onClick={() => handleCurrentShift()}
                  icon={<CloseCircleFilled />}
                />
                </div>
                </div>
          )}
          {step === 3 && (
 <div className="width100P">
 <h4 style={{fontWeight: "bold"}}>Select Machine to Sync</h4>
 <Form>
              <Form.Item name="machine name">
                <Select mode="multiple"
                placeholder="Select a machine"
                onChange = {(machines) => {setSelectedMachines(machines)}}
                defaultValue={selectedMachines}>
                  {lists?.machines.map(x => (
                    <Option disabled={canSyncMachine(x) ?  true :false } key={x.machineName} value={x.machineName}>
                      {x.displayName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <div className="dflex alignCenter justifyCenter gap10">
                <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="blue"
                  text="Proceed"
                  onClick={() => productChange()}
                  icon={<CheckCircleFilled />}
                />
                <ButtonComp
                  className="btnBlue"
                  style={{ width: "100px" }}
                  theme="red"
                  text="Cancel"
                  onClick={() => handleModalClose()}
                  icon={<CloseCircleFilled />}
                />
              </div>
            </Form>
 </div>
          )}
          </Modal>
                        <ReworkRejection open={type === 3 ? modalStates['3'] : type === 4 ? modalStates['4'] : false} handleCancel={type === 3 ? () => { handleModal('close', 3) } : type === 4 ? () => { handleModal('close', 4) } : () => { }} type={type} />

                        {/* <BasicModal id="5" title="Force Stop" children={FStopModalData} btn1Text="Yes" btn2Text="No" open={modalStates['5'] || false}
                            handleOK={async () => {
                                await forceStopShift(dispatch, current)
                                handleModal('close', 5)
                            }}
                            handleCancel={() => handleModal('close', 5)}
                            loading={componentLoaders?.force || false}
                        /> */}
                        { <BasicModal id="6" title="Edit Comment" children={EditCommentModal} btn1Text="Save" btn2Text="Cancel" open={modalStates['6'] || false}
                            handleOK={async () => {
                                // await forceStopShift(dispatch, current)
                                handleSaveComment()
                                handleModal('close', 6)
                            }}
                            handleCancel={() => handleModal('close', 6)}
                            loading={componentLoaders?.force || false}
                        /> }

                        <ButtonComp
                            onClick={handleMerge}
                            theme={validateForMerge(checkedDowntimes)?.isValid ? "blue" : "gray"}
                            text="Merge" icon={<SwapOutlined />} />

                        <ButtonComp
                            onClick={() => {
                                let { error = '', isValid } = validateForSplit(checkedDowntimes);
                                !isValid ? info(error) : handleModal('open', 2)
                            }}
                            theme={validateForSplit(checkedDowntimes)?.isValid ? "blue" : "gray"}
                            text="Split" icon={<SwapOutlined />} />

                            <ButtonComp
                            onClick={() => {
                                handleProductModal('open', 7)
                            }}
                            theme="blue"
                            text="Change" icon={<RetweetOutlined />} />

                        <Divider />
                        <RangePicker showTime={{ format: 'HH:mm' }} value={[moment(lineOpRange.start), moment(lineOpRange.end)]} onChange={onLineOpRangeChange} className="boxBorder boxBorderRad" size="medium" style={{ padding: "8px", width: "100%" }} allowClear={false} format="YYYY-MM-DD" />
                        <Divider />
                        <ButtonComp onClick={onRejectionClick} theme={canPerformAction(current, access_capabilities.canCreateRejections) ? 'white' : 'gray'} text="Rejection" icon={<SwapOutlined />} />
                        <ButtonComp onClick={onReworkClick} theme={canPerformAction(current, access_capabilities.canCreateRework) ? 'blue' : 'grey'} text="Rework" icon={<RedoOutlined />} />
                        {/* <ButtonComp onClick={() => handleModal('open', 5)} theme={canForceStop(current, lists) ? 'red' : 'grey'} text="Force Stop" icon={<CloseCircleOutlined />} style={{ minWidth: "120px" }} /> */}
                        <ForceShiftStop />
                    </div>
                </div>
                <div className='lineOp_tale'>
                    <CustomTable rowSelection={rowHandler} dataSource={downtimes} columns={LineOpColumns} checkbox={true} hideSelectAllCheckbox={true} />
                    {/* rowSelection : { hideSelectAllCheckbox : true }  */}
                    <MainDrawer drawerData={{ open, onClose }} children={LineOpDrawerData} title="Add Reason" placement={"right"} extra={<ButtonComp onClick={handleSave} theme={isReasonSelected ? "blue" : "gray"} text="Save"  disabled={!isReasonSelected} icon={<CheckCircleOutlined />} />} width={1000} />
                </div>
            </div>
        </Loader>
    )
}

export default LineOperatorComp
